import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-cards.css';
import { EGDSCardPlaceholderStartPhases, EGDSCardPlaceholderAspectRatios } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSCardPlaceholder = props => {
  const {
    aspectRatio,
    children,
    className,
    startPhase = EGDSCardPlaceholderStartPhases.get('light'),
    ...attributes
  } = props;
  let secondaryButton;
  // Map through the children and place the ones we want in specific places
  React.Children.forEach(children, child => {
    if (!child) {
      return;
    }
    if (child.type.displayName?.match(/(EGDS|Uitk)SecondaryButton/)) {
      secondaryButton = child;
    }
  });
  const baseClass = 'uitk-card-placeholder';
  const ratioClass = aspectRatio ? EGDSCardPlaceholderAspectRatios.get(aspectRatio) : EGDSCardPlaceholderAspectRatios.get('r1-3');
  const cssClassNames = getClassNameList(baseClass, !secondaryButton && `${baseClass}-animate-from-${startPhase}`, secondaryButton && `${baseClass}-has-action`, className, `${baseClass}-${ratioClass}`);
  if (secondaryButton) {
    return jsx("div", {
      className: cssClassNames,
      ...attributes,
      children: jsx(EGDSLayoutFlex, {
        alignItems: "center",
        className: getClassNameList('uitk-card-placeholder-has-action-inner'),
        justifyContent: "center",
        children: jsx(EGDSLayoutFlexItem, {
          children: secondaryButton
        })
      })
    });
  }
  return jsx("div", {
    className: cssClassNames,
    ...attributes
  });
};
EGDSCardPlaceholder.displayName = 'EGDSCardPlaceholder';
// Temporary, unstable
const EGDSCardAlohaPlaceholder = EGDSCardPlaceholder;
export { EGDSCardAlohaPlaceholder, EGDSCardPlaceholder };